<template>
  <v-overlay z-index="100000">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
  </v-overlay>
</template>

<script>
  export default {
    name: 'Loader',
  }
</script>

<style src="spinkit/spinkit.css" lang="css" />
